import { useState } from 'react';
import { useAppForm } from 'shared/UI/UIKit/Form';
import { useUpdateMaxLessonsPerDayMutation, type MaxLessonsPerDay } from 'shared/api';

interface UseMaxLessonsPerDayEditProps {
  maxLessonsPerDay: MaxLessonsPerDay;
  refreshTable: () => void;
}

export const useMaxLessonsPerDayEdit = ({
  maxLessonsPerDay,
  refreshTable,
}: UseMaxLessonsPerDayEditProps) => {
  const [modalVisible, setModalVisible] = useState(false);

  const [form] = useAppForm<MaxLessonsPerDay>();
  const [updateMaxLessonsPerDay] = useUpdateMaxLessonsPerDayMutation();

  const showModal = () => {
    setModalVisible(true);
    form.setFieldsValue(maxLessonsPerDay);
  };

  const hideModal = () => {
    setModalVisible(false);
  };

  const onSubmit = async () => {
    await form.validateFields().then(async (values) => {
      await updateMaxLessonsPerDay({ ...values, id: maxLessonsPerDay.id })
        .unwrap()
        .then(() => {
          hideModal();
          refreshTable();
        });
    });
  };

  return {
    state: {
      modalVisible,
      form,
    },
    methods: {
      showModal,
      hideModal,
      onSubmit,
    },
  };
};
